
import Vue from "vue";
import AppStoredSettings from "./ExcelMapperStoredSettings.vue";
import AppSettingsEditor from "./ExcelMapperSettingsEdit.vue";
import AppExcelMapperRunner from "./ExcelMapperRunner.vue";
import { ExcelMapperSettings } from "@/models/excel-mapper-settings";
import { IExcelMapperExtraData } from "@/services/price-list-product-service";

export default Vue.extend({
	data(){
		return {
			editSettings: null as null | ExcelMapperSettings,
			settings: null as null | ExcelMapperSettings
		};
	},
	props: {
		service: {
			type: Object as ()=>ExcelMapperSettings,
			required: true
		},
		allowedOutputHeaders: {
			type: Array as ()=>string[],
			required: true
		}
	},
	methods: {
		closeSettingsEditor(){
			this.editSettings = null;
		},
		close(){
			this.$emit("close");
		},
		onExcelFileCreated(file:File, extraData:IExcelMapperExtraData){
			this.$emit("file", file, extraData || {});
			this.close();
		}
	},
	components: {
		AppStoredSettings,
		AppSettingsEditor,
		AppExcelMapperRunner
	}
});
